import 'jquery-migrate'

import './iframeResizer'
import './jquery.bxslider'
import './jquery.cookie'
import './jquery.focuspoint'
import './jquery.validate'
import './jquery.validate.unobtrusive'
import './jquery.visible.min'
import './modernizr.custom'
